import { Button, Empty, Row, Spin } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import { PropsWithChildren, useRef, useState, useEffect } from 'react'

import { useDownload } from '@hooks'
import { FileType } from '@types'

import useTicketFiles from '../../../TicketFiles/hooks'
import InfoSection from '../components/InfoSection'

interface FilesSectionProps {
  files: FileType[]
}

const FilesSection: React.FC<PropsWithChildren<FilesSectionProps>> = ({ files, children }) => {
  const { getFile } = useTicketFiles()
  const { downloadFile, isLoading: isDownloading, keyDowloading } = useDownload()
  const [fileUrl, setFileUrl] = useState<string | undefined>()
  const [onlyDownload, setOnlyDownload] = useState(false)
  const linkRef = useRef<HTMLAnchorElement | null>(null)

  const handleOpenFile = (fileId: number) => {
    getFile(fileId, {
      onSuccess: (data: { fileToDownload: string }) => {
        setFileUrl(data.fileToDownload)
        setOnlyDownload(false)
      },
    })
  }

  useEffect(() => {
    if (fileUrl && linkRef.current && !onlyDownload) {
      const link = linkRef.current
      link.click()
      setOnlyDownload(true)
    }
  }, [fileUrl, onlyDownload])

  return (
    <InfoSection header="Anexos">
      {files?.length ? (
        <>
          {files.map(fileMapped => (
            <Button
              key={fileMapped.id}
              onClick={() => handleOpenFile(fileMapped.id)}
              type="link"
              block
              size="small"
              style={{ paddingLeft: 0, paddingRight: 0 }}
            >
              <Row justify="space-between" align="middle">
                {fileMapped.fileName.length > 25
                  ? `${fileMapped.fileName.slice(0, 25)}...`
                  : fileMapped.fileName}
                {isDownloading && keyDowloading === fileMapped.ticketFile ? (
                  <Spin spinning size="small" />
                ) : (
                  <DownloadOutlined
                    onClick={e => {
                      e.stopPropagation()
                      downloadFile({
                        key: fileMapped.ticketFile!,
                        name: fileMapped.fileName,
                      })
                      setOnlyDownload(true)
                    }}
                  />
                )}
              </Row>
            </Button>
          ))}
        </>
      ) : (
        <Empty />
      )}
      {children}

      {fileUrl && !onlyDownload && (
        <a
          ref={linkRef}
          href={fileUrl}
          style={{ display: 'none' }}
          target="_blank"
          rel="noopener noreferrer"
        >
          Open File
        </a>
      )}
    </InfoSection>
  )
}

export default FilesSection
